import { render, staticRenderFns } from "./VerificationSent.vue?vue&type=template&id=3d667cfe&"
import script from "./VerificationSent.vue?vue&type=script&lang=js&"
export * from "./VerificationSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports